import FeesCard from "./FeesCard";

export default function Class1() {
  return (
    <FeesCard
      badge="Class 1"
      title="💰 Class 1 Tuition Details"
      className="1st Standard"
      fee="₹800"
      days="Monday – Saturday"
      time="4:30 PM – 7:30 PM"
      subjects={[
        "English (Reading, Writing & Phonics)",
        "Mathematics (Numbers & Basics)",
        "EVS (Environmental Awareness)",
        "Daily homework support"
      ]}
      approach={[
        "Individual attention",
        "Concept-based learning",
        "Regular revision & practice",
        "Child-friendly teaching methods"
      ]}
      note="₹500 extra for evening snacks / milk.
      Self pickup & drop only."
    />
  );
}
